import { IListItem } from '../../../../interfaces/listItem';
import { getProficiencyByNumber, ILanguage } from '../../../../interfaces/language';
import { useCallback, useContext, useMemo } from 'react';
import { Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { BoxFullWidth } from '../../../common/boxes';
import ProfileListItem from '../common/ProfileListItem';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FreelancerService } from '../../../../services/freelancer';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../../interfaces/errorResponse';
import { FreelancerContext } from '../FreelancerEntity';
import { FREELANCER_ENTITY_QUERY_KEY } from '../../../../queryHooks/freelancer/useGetFreelancerEntity';
import { useGetLanguageCodes } from '../../../../queryHooks/useGetLanguageCodes';
import { useNotification } from '../../../../+state/useNotification';

const LanguageListItem = ({ entity, queryParam }: IListItem<ILanguage>) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const { openErrorToast, openSuccessToast } = useNotification();
  const { data: codes } = useGetLanguageCodes();
  const { user } = useContext(FreelancerContext);
  const langName = useMemo(() =>
    (codes || []).find(c => c.code === entity.languageCode)?.name || entity.languageCode, [codes, entity.languageCode]);

  const mutation = useMutation({
    mutationFn: () => FreelancerService.deleteLanguage(user.id, entity.id!),
    onSuccess: () => {
      openSuccessToast('Successfully deleted');
      queryClient.invalidateQueries([FREELANCER_ENTITY_QUERY_KEY]);
    },
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(err.response?.data.message || err.message);
    }
  });
  
  const handleClickEditBtn = useCallback(() => {
    searchParams.set(queryParam, entity?.id || '');
    setSearchParams(searchParams);
  }, [searchParams, entity?.id, setSearchParams, queryParam]);

  return (
    <ProfileListItem deleteHandler={mutation.mutate} editHandler={handleClickEditBtn}>
      <BoxFullWidth>
        <Typography>
          {`${langName} - ${getProficiencyByNumber(entity.proficiencyLevel)}`}
        </Typography>
      </BoxFullWidth>

    </ProfileListItem>
  );
};

export default LanguageListItem;